<div
  class="d-flex flex-column justify-content-center align-items-center text-center w-100 h-100 p-4"
  style="min-height: 100vh"
>
  <img
    src="images/error.svg"
    alt="Maintenance"
    style="height: 200px"
    class="mb-5"
  />

  <p class="mb-0">
    {{ config.message }}
  </p>
</div>
